import { AuthDocument } from '../../graphql/graphql';

export const sendAccessToken = AuthDocument;
